import { ISidebarNavigation } from '../../models/sidebar-navigation/ISidebarNavigation';

export function getCourseSubMenu(translate: any): ISidebarNavigation {
  return {
    links: [
      {
        fields: {
          displayName: translate('Courses.coursePageNavigation.keyInformation'),
          urlLink: '#course-key-information',
          application: 'Both',
        },
      },
      { fields: { displayName: translate('Courses.coursePageNavigation.courseDetails'), urlLink: '#course-details', application: 'Both' } },
      {
        fields: {
          displayName: translate('Courses.coursePageNavigation.moreAboutThisCourse'),
          urlLink: '#course-key-information',
          application: 'Both',
        },
      },
      {
        fields: {
          displayName: translate('Courses.coursePageNavigation.pathwayToDirectEntry'),
          urlLink: '#course-key-information',
          application: 'Both',
        },
      },
      {
        fields: {
          displayName: translate('Courses.coursePageNavigation.progresionDetails'),
          urlLink: '#course-key-information',
          application: 'Both',
        },
      },
    ],
  };
}
export function getSummarySubMenu(translate: any): ISidebarNavigation {
  return {
    links: [
      {
        fields: {
          displayName: translate('Courses.summaryPageNavigation.courseOverview'),
          urlLink: '#summary-overview',
          application: 'Both',
        },
      },
      {
        fields: {
          displayName: translate('Courses.summaryPageNavigation.keyInformation'),
          urlLink: '#key-information',
          application: 'Both',
        },
      },
      {
        fields: {
          displayName: translate('Courses.summaryPageNavigation.degress'),
          urlLink: '#summary-details',
          application: 'Both',
        },
      },
    ],
  };
}
